function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import Divider from "../../../basic/Divider";
import Button from "../../../basic/Button";
import DropDown from "../../../basic/DropDown";
import { color, font } from "../../../../styles/theme";
import Checkbox from "../../../basic/Checkbox";
import { SvgChevronDown } from "../../../../svg";

/**
 * This is a filter that lets you select multiple options
 * You need to provide buttonContentRenderer to render the expected multi-select text and unselected text
 * see example in src/stories/support/TableV2/demos/ToolbarTableMultiSelectDemo.js
 */
var MultiSelectDropdownFilter = /*#__PURE__*/function (_React$Component) {
  function MultiSelectDropdownFilter(props, context) {
    var _this;
    _classCallCheck(this, MultiSelectDropdownFilter);
    _this = _callSuper(this, MultiSelectDropdownFilter, [props, context]);
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      var selectedOptionIndices = _this.props.selectedOptionIndices;
      if (selectedOptionIndices && selectedOptionIndices !== prevProps.selectedOptionIndices) {
        _this.setState({
          selectedOptionsMap: _this.setSelectedOptionsMap(selectedOptionIndices)
        });
      }
    });
    _defineProperty(_this, "handleSelectOption", function (index, option) {
      var onUpdate = _this.props.onUpdate;
      _this.setState(function (_ref) {
        var selectedOptionsMap = _ref.selectedOptionsMap;
        var selectedOptionsMapObj = selectedOptionsMap;
        if (selectedOptionsMap[index]) {
          delete selectedOptionsMapObj[index];
          return {
            selectedOptionsMap: selectedOptionsMapObj
          };
        }
        return {
          selectedOptionsMap: _objectSpread(_objectSpread({}, selectedOptionsMap), {}, _defineProperty({}, index, option))
        };
      }, function () {
        var selectedOptionsMap = _this.state.selectedOptionsMap;
        var selectedOptions = Object.values(selectedOptionsMap);
        onUpdate(selectedOptions.length === 0 ? undefined : selectedOptions);

        // make sure the focused index is updated
        _this.onHover(undefined);
      });
    });
    _defineProperty(_this, "handleSelectAll", function () {
      var _this$props = _this.props,
        onUpdate = _this$props.onUpdate,
        options = _this$props.options;
      _this.setState(function (_ref2) {
        var selectedOptionsMap = _ref2.selectedOptionsMap;
        if (Object.keys(selectedOptionsMap).length === options.length) {
          // all selected
          return {
            selectedOptionsMap: {}
          };
        }
        return {
          selectedOptionsMap: options.reduce(function (map, option, index) {
            return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, index, option));
          }, {})
        };
      }, function () {
        var selectedOptionsMap = _this.state.selectedOptionsMap;
        var selectedOptions = Object.values(selectedOptionsMap);
        onUpdate(selectedOptions.length === 0 ? undefined : selectedOptions);

        // make sure the focused index is updated
        _this.onHover(undefined);
      });
    });
    _defineProperty(_this, "onHover", function (index) {
      _this.setState({
        focusedIndex: index
      });
    });
    _defineProperty(_this, "setSelectedOptionsMap", function (selectedOptionIndices) {
      if (!selectedOptionIndices || selectedOptionIndices.length === 0) {
        return {};
      }
      var selectedOptionsMap = {};
      var options = _this.props.options;
      selectedOptionIndices.forEach(function (index) {
        selectedOptionsMap[index] = options[index];
      });
      return selectedOptionsMap;
    });
    _defineProperty(_this, "optionRenderer", function (_ref3) {
      var option = _ref3.option,
        index = _ref3.index;
      var _this$state = _this.state,
        selectedOptionsMap = _this$state.selectedOptionsMap,
        focusedIndex = _this$state.focusedIndex;
      var options = _this.props.options;
      var isOptionSelected = !!selectedOptionsMap[index] || index === -1 && Object.keys(selectedOptionsMap).length === options.length;
      var additionalProps = {};
      if (focusedIndex === index) {
        additionalProps.checkedColor = color.white;
      } else {
        additionalProps.checkedColor = color.primary;
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, _extends({
        checked: isOptionSelected,
        uncheckedHoverColor: color.border,
        checkedHoverColor: color.white
      }, additionalProps), option.label));
    });
    _this.state = {
      selectedOptionsMap: _this.setSelectedOptionsMap(props.selectedOptionIndices),
      focusedIndex: undefined
    };
    return _this;
  }
  _inherits(MultiSelectDropdownFilter, _React$Component);
  return _createClass(MultiSelectDropdownFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        options = _this$props2.options,
        value = _this$props2.value,
        optionRenderer = _this$props2.optionRenderer,
        buttonContentRenderer = _this$props2.buttonContentRenderer,
        selectAllTitle = _this$props2.selectAllTitle,
        width = _this$props2.width,
        maxHeight = _this$props2.maxHeight;
      var selectedOptionsMap = this.state.selectedOptionsMap;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DropDown.ButtonMenuV2, {
        dropDownPosition: {
          vertical: 'bottom',
          horizontal: 'right'
        },
        maxHeight: maxHeight || 200,
        leaveMenuOpenOnItemClick: true,
        renderButton: function renderButton(_ref4) {
          var getDropDownButtonProps = _ref4.getDropDownButtonProps;
          return /*#__PURE__*/React.createElement("div", {
            style: {
              border: '1px solid var(--cds-color-grey-25, #E1E1E1)',
              marginLeft: 12,
              height: 46
            }
          }, /*#__PURE__*/React.createElement(Button, _extends({
            style: {
              width: width || 200,
              minHeight: 46,
              height: 46,
              padding: 12,
              fontSize: font.sm,
              color: Object.keys(selectedOptionsMap).length > 0 ? color.primaryText : color.secondaryText,
              fontWeight: 'inherit'
            },
            size: "zero",
            type: "icon",
            _refAlt: getDropDownButtonProps().ref
          }, _objectSpread(_objectSpread({}, getDropDownButtonProps()), {}, {
            ref: undefined
          })), /*#__PURE__*/React.createElement("span", {
            style: {
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }
          }, buttonContentRenderer(value)), /*#__PURE__*/React.createElement(SvgChevronDown, {
            size: 16,
            style: {
              marginLeft: 6
            }
          }))));
        }
      }, selectAllTitle && /*#__PURE__*/React.createElement(DropDown.Item, {
        onClick: function onClick() {
          return _this2.handleSelectAll();
        },
        htmlAttributes: {
          onMouseEnter: function onMouseEnter() {
            return _this2.onHover(-1);
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.onHover(undefined);
          },
          onFocus: function onFocus() {
            return _this2.onHover(-1);
          },
          onBlur: function onBlur() {
            return _this2.onHover(undefined);
          }
        },
        style: {
          padding: '0.75rem 0.75rem'
        }
      }, optionRenderer ? optionRenderer({
        option: {
          label: selectAllTitle
        },
        value: value,
        index: -1
      }) : this.optionRenderer({
        option: {
          label: selectAllTitle
        },
        index: -1,
        value: value
      })), selectAllTitle && /*#__PURE__*/React.createElement(Divider, null), options.map(function (option, index) {
        return /*#__PURE__*/React.createElement(DropDown.Item, {
          onClick: function onClick() {
            return _this2.handleSelectOption(index, option);
          },
          htmlAttributes: {
            onMouseEnter: function onMouseEnter() {
              return _this2.onHover(index);
            },
            onMouseLeave: function onMouseLeave() {
              return _this2.onHover(undefined);
            },
            onFocus: function onFocus() {
              return _this2.onHover(index);
            },
            onBlur: function onBlur() {
              return _this2.onHover(undefined);
            }
          },
          style: {
            padding: '0.75rem 0.75rem'
          }
        }, optionRenderer ? optionRenderer({
          option: option,
          value: value,
          index: index
        }) : _this2.optionRenderer({
          option: option,
          index: index,
          value: value
        }));
      })));
    }
  }]);
}(React.Component);
export default MultiSelectDropdownFilter;